import React, { useState } from "react";
//import "./styles.css";
import { Button, Form } from "react-bootstrap";
// import LeftpanelMember from "../../../components/leftpanel/left-panel-admin";
// import HeaderPart from "../../../components/layout/header-admin/header";
import "./login.css";
import { useHistory } from "react-router-dom";
import { LoginBanner, Logo } from "../../assets/images";
import axios from "../../axios/axios";
import { message } from "antd";

const LoginPage = () => {
  const navigate = useHistory();
  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const login = async (e) => {
    e.preventDefault();

    await axios
      .post(`/login`, user)
      .then((res) => {
        if (res.data.status) {
          message.success("login successfully");
          localStorage.setItem("AuthToken", res.data.token);
          localStorage.setItem("AdminData", JSON.stringify(res.data.data));

          navigate.push("/dashboard");
        } else {
          message.error("login failed");
        }
      })
      .catch((err) => {
        console.log("err", err);
        message.error("Something went wrong");
      });
  };

  const registration = () => {
    // jimmy@tripvalet.com jennifer@tripvalet.com
    let userData = {
      name: "Jimmy",
      email: "jimmy@tripvalet.com",
      password: "12345678",
    };

    axios
      .post("/admin-registration", userData)
      .then((res) => {
        console.log("res", res);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="main_cont">
      <div className="login_page">
        <div className="login_page_left">
          <img src={LoginBanner} className="img-fluid" alt="Banner Icon" />
        </div>
        <div className="login_page_right">
          <div className="login_page_right_inner">
            <div className="login_inner_logo">
              <img src={Logo} alt="Login Icon" />
            </div>
            <div className="login_inner_bottom">
              <Form>
                <Form.Group className="mb-4" controlId="formBasicEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control
                    type="email"
                    className="login_field"
                    placeholder="Enter email"
                    value={user.email}
                    onChange={(e) =>
                      setUser({
                        ...user,
                        email: e.target.value,
                      })
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    className="login_field"
                    placeholder="Password"
                    value={user.password}
                    onChange={(e) =>
                      setUser({
                        ...user,
                        password: e.target.value,
                      })
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                  <Form.Check type="checkbox" label="Remember Me" />
                </Form.Group>
                <div className="forgot_pass">
                  <a href="#">Forgot Password?</a>
                </div>
                <div className="login_submit">
                  <Button
                    variant="primary"
                    type="button"
                    className="sub_log_but"
                    onClick={login}
                  >
                    Log In
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
